import * as React from 'react';
import { WritingSectionAnswerState } from './states/WritingSectionAnswerState';
import { observer } from 'mobx-react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { WritingQuestion, WritingQuestionType } from '../../../../commonv3/types/writingQuestions';
import { MultiSelectQuestionView, SingleSelectQuestionView } from '../writing_questions/WritingQuestionView';
import classNames from 'classnames';
import './examWritingSectionScoreView.module.scss';
import { TwitterShareButton } from '../../atoms/buttons/TwitterShareButton';
import { FacebookShareButton } from '../../atoms/buttons/FacebookShareButton';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';

const SectionBackground = ({ score }) => {
    var backgroundColor = 'blue';
    if (score > 69) {
        backgroundColor = 'red';
    } else if (score > 39) {
        backgroundColor = 'green';
    }
    return (
        <div styleName={classNames('section-background', backgroundColor)}>
            <div styleName="left" />
            <div styleName="right" />
        </div>
    );
};

const SectionHeader = ({ title }) => (
    <div styleName="section-header-wrapper">
        <div styleName="section-header">
            <div styleName="section-header-text1">RESULT</div>
            <div styleName="section-header-text2">筆記試験結果</div>
            <div styleName="section-header-text3">{title}</div>
        </div>
    </div>
);

type ScoreSummaryProps = {
    questions: WritingQuestion[];
    answers: WritingSectionAnswerState;
    subHeader: string;
};

const ScoreSummary = ({ questions, answers, subHeader }: ScoreSummaryProps) => {
    return (
        <div styleName={classNames('score-summary', { perfect: answers.score == 100 })}>
            <div styleName="score-summary-inner">
                <div styleName="score-summary-subheader">
                    <span>\</span>
                    {subHeader}
                    <span>/</span>
                </div>
                <div styleName="score-summary-header">
                    <span styleName="score-num">{answers.score}</span>点
                </div>
                <div styleName="score-summary-footer">
                    <span styleName="correct-answers">{answers.correctAnswersCount()}</span>/<span styleName="total-answers">
                        {questions.length}
                    </span>{' '}
                    問正解
                </div>
            </div>
        </div>
    );
};

const ShareScorePane = ({ twitterDataText, ogpUrl }) => (
    <div styleName="sharing-pane">
        <div styleName="sharing-pane-title">結果をシェアしよう</div>
        <div styleName="button-toolbar">
            <TwitterShareButton dataText={twitterDataText} dataUrl={ogpUrl}>
                Twitterでシェア
            </TwitterShareButton>
            <FacebookShareButton dataUrl={ogpUrl}>Facebookでシェア</FacebookShareButton>
        </div>
    </div>
);

const SectionBody = ({ children }) => (
    <div styleName="section-body-wrapper">
        <div styleName="section-body">{children}</div>
    </div>
);
const SectionFooter = ({ children }) => (
    <div styleName="section-footer-wrapper">
        <div styleName="section-footer">{children}</div>
    </div>
);

type Props = {
    answerState: WritingSectionAnswerState;
    onExit: () => any;
    title: string;
    code: string;
};
@observer
export class ExamWritingSectionScoreView extends React.Component<Props> {
    subHeader = (score: number): string => {
        if (score >= 80) {
            return 'やったね';
        } else if (score >= 39) {
            return 'おしい！もう少し';
        } else {
            return 'ガンバろう';
        }
    };
    twitterDataText = (title, score: number): string => {
        if (score >= 80) {
            return `「${title}コース」の筆記試験をクリアしました！`;
        } else {
            return `「${title}コース」の筆記試験にチャレンジしました`;
        }
    };
    render() {
        const { answerState, onExit, title, code } = this.props;
        const { questions } = answerState;
        const ogpUrl = `https://likes.she-inc.jp/v3/writing_section_submissions/${code}`;
        return (
            <div styleName="view">
                <SectionBackground score={answerState.score} />
                <SectionHeader title={title} />
                <ScoreSummary
                    questions={questions}
                    answers={answerState}
                    subHeader={this.subHeader(answerState.score)}
                />
                <ShareScorePane twitterDataText={this.twitterDataText(title, answerState.score)} ogpUrl={ogpUrl} />
                <SectionBody>
                    <div styleName="body-title">テストの解説</div>
                    {questions.map((question, index) => {
                        switch (question.question_type) {
                            case WritingQuestionType.SINGLE_SELECT:
                                return (
                                    <SingleSelectQuestionView
                                        key={question.id}
                                        index={index + 1}
                                        question={question}
                                        answerState={answerState.getSingleSelectAnswerState(question)}
                                        showAnswer={true}
                                    />
                                );
                            case WritingQuestionType.MULTI_SELECT:
                                return (
                                    <MultiSelectQuestionView
                                        key={question.id}
                                        index={index + 1}
                                        question={question}
                                        answerState={answerState.getMultiSelectAnswerState(question)}
                                        showAnswer={true}
                                    />
                                );
                        }
                    })}
                </SectionBody>
                <SectionFooter>
                    <div styleName="end-words">
                        テストお疲れ様でした。<SpBr />ひき続き頑張りましょう!
                    </div>
                    <Button styleName="button" type="primary" size="l" onClick={onExit}>
                        レッスン画面へ
                    </Button>
                </SectionFooter>
            </div>
        );
    }
}
